import React from 'react';
import { View } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import { IS_WEB } from '@/utils/platform';

export const Grid = ({
  color,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg
          width={size}
          height={size}
          viewBox="0 0 44 44"
          fill="none"
          style={style as React.CSSProperties}
        >
          <path
            d="M12 12.8C12 12.3582 12.3582 12 12.8 12H20.2C20.6418 12 21 12.3582 21 12.8V20.2C21 20.6418 20.6418 21 20.2 21H12.8C12.3582 21 12 20.6418 12 20.2V12.8ZM14.3 14C14.1343 14 14 14.1343 14 14.3V18.7C14 18.8657 14.1343 19 14.3 19H18.7C18.8657 19 19 18.8657 19 18.7V14.3C19 14.1343 18.8657 14 18.7 14H14.3ZM12 23.8C12 23.3582 12.3582 23 12.8 23H20.2C20.6418 23 21 23.3582 21 23.8V31.2C21 31.6418 20.6418 32 20.2 32H12.8C12.3582 32 12 31.6418 12 31.2V23.8ZM14.3 25C14.1343 25 14 25.1343 14 25.3V29.7C14 29.8657 14.1343 30 14.3 30H18.7C18.8657 30 19 29.8657 19 29.7V25.3C19 25.1343 18.8657 25 18.7 25H14.3ZM23 12.8C23 12.3582 23.3582 12 23.8 12H31.2C31.6418 12 32 12.3582 32 12.8V20.2C32 20.6418 31.6418 21 31.2 21H23.8C23.3582 21 23 20.6418 23 20.2V12.8ZM25.3 14C25.1343 14 25 14.1343 25 14.3V18.7C25 18.8657 25.1343 19 25.3 19H29.7C29.8657 19 30 18.8657 30 18.7V14.3C30 14.1343 29.8657 14 29.7 14H25.3ZM23 23.8C23 23.3582 23.3582 23 23.8 23H31.2C31.6418 23 32 23.3582 32 23.8V31.2C32 31.6418 31.6418 32 31.2 32H23.8C23.3582 32 23 31.6418 23 31.2V23.8ZM25.3 25C25.1343 25 25 25.1343 25 25.3V29.7C25 29.8657 25.1343 30 25.3 30H29.7C29.8657 30 30 29.8657 30 29.7V25.3C30 25.1343 29.8657 25 29.7 25H25.3Z"
            fill={color}
          />
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      style={style}
      {...props}
    >
      <Path
        d="M12 12.8C12 12.3582 12.3582 12 12.8 12H20.2C20.6418 12 21 12.3582 21 12.8V20.2C21 20.6418 20.6418 21 20.2 21H12.8C12.3582 21 12 20.6418 12 20.2V12.8ZM14.3 14C14.1343 14 14 14.1343 14 14.3V18.7C14 18.8657 14.1343 19 14.3 19H18.7C18.8657 19 19 18.8657 19 18.7V14.3C19 14.1343 18.8657 14 18.7 14H14.3ZM12 23.8C12 23.3582 12.3582 23 12.8 23H20.2C20.6418 23 21 23.3582 21 23.8V31.2C21 31.6418 20.6418 32 20.2 32H12.8C12.3582 32 12 31.6418 12 31.2V23.8ZM14.3 25C14.1343 25 14 25.1343 14 25.3V29.7C14 29.8657 14.1343 30 14.3 30H18.7C18.8657 30 19 29.8657 19 29.7V25.3C19 25.1343 18.8657 25 18.7 25H14.3ZM23 12.8C23 12.3582 23.3582 12 23.8 12H31.2C31.6418 12 32 12.3582 32 12.8V20.2C32 20.6418 31.6418 21 31.2 21H23.8C23.3582 21 23 20.6418 23 20.2V12.8ZM25.3 14C25.1343 14 25 14.1343 25 14.3V18.7C25 18.8657 25.1343 19 25.3 19H29.7C29.8657 19 30 18.8657 30 18.7V14.3C30 14.1343 29.8657 14 29.7 14H25.3ZM23 23.8C23 23.3582 23.3582 23 23.8 23H31.2C31.6418 23 32 23.3582 32 23.8V31.2C32 31.6418 31.6418 32 31.2 32H23.8C23.3582 32 23 31.6418 23 31.2V23.8ZM25.3 25C25.1343 25 25 25.1343 25 25.3V29.7C25 29.8657 25.1343 30 25.3 30H29.7C29.8657 30 30 29.8657 30 29.7V25.3C30 25.1343 29.8657 25 29.7 25H25.3Z"
        fill={color}
      />
    </Svg>
  );
};
